import Tracking from "@t8891/tracking";

const IS_PRODUCTION = process.env.SERVER_ENV === "production";

const userMessage = localStorage.getItem("userMessage");

/** 处理埋点 */
const track = new Tracking({
  debug: !IS_PRODUCTION,
  gaParams: {
    user_id: !!userMessage ? JSON.parse(userMessage).mId : "",
    device_id: localStorage.getItem("uuid"),
    sub_platform: "PC",
  },
  trackApi: !IS_PRODUCTION
    ? "https://assets.8891.com.tw/track-debug/pc/c.8891.com.tw/new-car-config-track.json"
    : "https://assets.8891.com.tw/track/pc/c.8891.com.tw/new-car-config-track.json",

  ignoreApiList: [
    "https://stats.g.doubleclick.net/j/collect",
    "https://securepubads.g.doubleclick.net",
    "https://dc.8891.tw/api/generic",
    "https://securepubads.g.doubleclick.net/pcs/view",
    "https://c.8891.com.tw/api/v3/sales/popup",
    "https://securepubads.g.doubleclick.net/pagead/ppub_config",
    "https://www.google-analytics.com/j/collect",
    "https://web.dev.8891.com.tw/",
    "https://dc.dev.8891.tw/api/behavioral_push",
    "https://dc.8891.tw/collect",
    "https://c.dev.8891.com.tw/ws",
    "https://newcar.dev.8891.com.tw",
  ],
});

if (["newCar:trialrun/{brand}/{kind}/{id}", "newCar:news/{brand}/{kind}/{id}"].includes(window.page_route)) {
  carModelData?.map((item: any) => {
    const { brandId, kindId, modelId, myid, brandName, kindName, modelName, modelYear } = item;
    const params = {
      brand_id: brandId,
      kind_id: kindId,
      myid: myid,
      model_id: modelId,
      model_year: modelYear,
      kind: kindName,
      brand: brandName,
      model_year_fullname: modelName,
    };
    track.exposure("6.133.958.2648", params);
  });
}
